<template>
  <div>
    <loading-state :size="50" v-if="loading" />
    <div v-else>
      <LoginForm
        v-if="mode === 'login'"
        :titleAlignment="titleAlignment"
        :signupAction="() => changeMode('join')"
        :forgotPasswordAction="forgotPasswordAction"
        title="Login"
        @success="success('login')"
      />
      <JoinForm
        v-if="mode === 'join'"
        :clientId="clientId"
        :code="code"
        :userId="userId"
        :titleAlignment="titleAlignment"
        :loginAction="() => changeMode('login')"
        title="Create User"
        @success="success('join')"
      />
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import JoinForm from "@/components/smart/forms/JoinForm";
import LoadingState from "@/components/display/LoadingState";
import LoginForm from "@/components/smart/forms/LoginForm";
import store from "@/store";

export default {
  name: "JoinLoginComboForm",
  components: {
    JoinForm,
    LoginForm,
    LoadingState,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    titleAlignment: {
      type: String,
      default: "center",
    },
  },
  setup(props, { emit }) {
    const mode = ref("join");
    const loading = ref(true);

    const changeMode = (newMode) => {
      mode.value = newMode;
    };

    const forgotPasswordAction = () => {
      window.open("/forgot-password");
    };

    onMounted(() => {
      store.dispatch("settings/fetch").then(() => {
        loading.value = false;
      });
    });

    const success = (type) => {
      store.dispatch("auth/userClientInfo", { reidentify: true });
      emit("success", type);
    };

    return {
      loading,
      mode,
      changeMode,
      success,
      forgotPasswordAction,
    };
  },
};
</script>
